<template>
  <div class="documents-list">
    <div class="document-card-wrapper" v-for="(item, index) in skeletonItems" :key="index">
      <BbSkeletonLoader type="image" />
      <BbSkeletonLoader type="list-item-two-line" />
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    const skeletonItems = [1, 2, 3, 4, 5];

    return {
      skeletonItems,
    };
  },
};
</script>

<style scoped lang="scss">
.documents-list {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-2;
  align-items: center;
  gap: $bb-spacing-2;

  .document-card-wrapper {
    display: flex;
    align-items: center;
    padding: $bb-spacing-2;
    background: $bb-neutral-0;

    .v-skeleton-loader {
      height: fit-content;
      background: $bb-neutral-0;

      :deep(.v-skeleton-loader__image) {
        width: 60px;
        height: 50px;
        margin: 0;
        border-radius: $bb-spacing-1;
        margin-right: $bb-spacing-3;
      }

      :deep(.v-skeleton-loader__text) {
        width: 112px;
        margin: 0;
        border-radius: $bb-spacing-1;
      }
    }

    :deep(.v-skeleton-loader__list-item-two-line) {
      background: $bb-neutral-0;

      .v-skeleton-loader__bone {
        gap: $bb-spacing-2;
      }
    }
  }
}
</style>
